import { DBCustomSelect } from "@db-ux/react-core-components";
import React from "react";
import type { ComponentProps } from "react";
import "./REDCustomSelect.css";

type REDCustomSelectProps = ComponentProps<typeof DBCustomSelect> & {
    /**
     * Keep error text in small size.
     * Default: false (error text will be displayed in normal/larger size)
     */
    keepSmallErrorText?: boolean;
};

const REDCustomSelect: React.FC<REDCustomSelectProps> = (props) => {
    const { keepSmallErrorText, ...dbCustomSelectProps } = props;

    // Apply wrapper class when we want normal-sized error text (default behavior)
    const wrapperClass = keepSmallErrorText !== true ? "red-custom-select-normal-error" : "";

    return (
        <div className={wrapperClass}>
            <DBCustomSelect {...dbCustomSelectProps}>{props.children}</DBCustomSelect>
        </div>
    );
};

export default REDCustomSelect;